export enum LayoutMutations {
    CHANGE_TITLE = 'changeTitle',
}
